import { Container, Button, Navbar, Nav, NavItem, NavDropdown, MenuItem, NavLink,FormControl ,Form, Alert, Col,Row} from 'react-bootstrap';
import React, { useState, Component, useMemo, useEffect } from 'react';
import {Sida,Rubrik,Stycke,ContentWrapper} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn, Loading, SpinnerX, CallDownload, CallAPIGet} from '../../services/useBackend';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle} from '../../services/misc';
import {MaterialReactTable} from 'material-react-table';

import Test from '../balkochhal/editRequestComponent';

function Report() {

    const {loading, data, Seek, Refresh} =  useBackend('/api/report/resourcediviations');
    const {loading:loadingmeta, data:metadata} =  useBackend(process.env.PUBLIC_URL+'/api/meta');    

      const [editRequestModalshow, setEditRequestModalshow] = useState(false);
    
      const [selectedRequestData, setSelectedRequestData] = useState({Contact: { Name:"N/A"}, RequestWF: [], RequestChilds : [], RequestLog : [], RequestFiles: [], UserID:0 });  
      const [contactData, setContactData] = useState({});

    var today = new Date(Date.now());
    //var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [startDate, setStartDate] = useState(today.toLocaleDateString());

    //var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth()+1, 0);
    var result = new Date(); // not instatiated with date!!! DANGER
    result.setDate(today.getDate() + 7);

    const [endDate, setEndDate] = useState(result.toLocaleDateString());

    const [reportFilter, setReportFilter] = useState(0);    

    const initialState = { density: 'compact', columnVisibility: { }};    

    useEffect(() => { Seek("&UserCategoryID="+reportFilter+"&startDate="+startDate+"&endDate="+endDate) }, [reportFilter, startDate, endDate]);

      const editRequestHandler = async (event, rowData)  =>  {
        console.log(rowData.original);
        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPIGet('/api/requests/' + rowData.original.Guid);
            setSelectedRequestData(jsondata.Request)
            setContactData(jsondata.Request.Contact);
            setEditRequestModalshow(!editRequestModalshow);
        }

    const columns = useMemo(() => [

            { size: 40, accessorKey: 'Identifier',   header: 'ID', enableColumnActions: false },
            { size: 40, accessorKey: 'Title',   header: 'Title', enableColumnActions: false } ,
            { size: 40, accessorKey: 'Name',   header: 'Task', enableColumnActions: false } ,
            { size: 40, accessorKey: 'estimatedTime',   header: 'estimatedTime', enableColumnActions: false } ,
            { size: 40, accessorKey: 'actualTime',   header: 'actualTime', enableColumnActions: false }  
        ]
    );    

    return(
        <ContentWrapper>
            {editRequestModalshow && <Test RequestData={selectedRequestData} MetaData={metadata} show={editRequestModalshow} fn={()=> {setEditRequestModalshow(!editRequestModalshow); Refresh();} } setSelectedRequestData={setSelectedRequestData} contactData={contactData} />  }
                <Sida>
                    <Rubrik>Resource Diviations</Rubrik>

                    <Row>
                        <Col>Startdate</Col>
                        <Col>Enddate</Col>
                        <Col>Resuource Cathegory</Col>
                    </Row>

                    <Row>
                        <Col><Form.Control type="date" name="Name"  placeholder="Startdate" value={startDate} onChange={async (e) => {await setStartDate(e.target.value); }} /></Col>
                        <Col><Form.Control type="date" name="Name_" placeholder="Enddate"   value={endDate}   onChange={async (e) => {setEndDate(e.target.value); }} /></Col>
                        <Col>
                            <Form.Select name="UserCategoryID" m onChange={async (e) => {setReportFilter(e.target.value); }} >
                                {/* <option key="0" value="0">Alla</option>                                            */}
                                {!loadingmeta && getOptions(metadata.UserCategories)}
                            </Form.Select>                    
                        </Col>
                        {/* <Col><Button variant='secondary' onClick={() => {Seek("?startdate="+startDate+"&enddate="+endDate+"&ShopId="+shopFilter)}}>Sök/Uppdatera</Button> </Col> */}
                    </Row>                    

                    {!loading &&                          
                    <MaterialReactTable columns={columns} data={data.reportcontent} initialState={initialState}
                        muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, rowsPerPageOptions: [25, 50, 75, 100], labelRowsPerPage:"Rader"}}
                
                        muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0', border: '0px dashed #e0e0e0'} }}
                        muiTableBodyRowProps={({ row }) => ({
                            onClick: (event) => {editRequestHandler(event, row);},sx: {cursor: 'pointer'},})}
                    />}                               
                </Sida>    
        </ContentWrapper>
      );
   }

export default Report;